<script lang="ts">
    import { cn } from "../cn";

    export let variant: "default" | "destructive" | "outline" | "secondary" | "ghost" = "default";
    export let size: "default" | "sm" | "lg" | "icon" | "icon-sm" = "default";
    export let type: "button" | "submit" | "reset" = "button";
    export let disabled = false;
    export let title: string | undefined = undefined;
    let className = "";
    export { className as class };

    const base =
        "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--ring)] cursor-pointer";

    const variants: Record<string, string> = {
        default:
            "bg-[var(--primary)] text-[var(--primary-foreground)] shadow-sm hover:brightness-110 active:brightness-95",
        destructive:
            "bg-[var(--destructive)] text-white shadow-sm hover:brightness-110 active:brightness-95",
        outline:
            "border border-[var(--border)] bg-[var(--input)]/30 hover:bg-[var(--input)]/50 text-[var(--foreground)]",
        secondary:
            "bg-[var(--secondary)] text-[var(--secondary-foreground)] hover:brightness-110",
        ghost:
            "hover:bg-[color-mix(in_oklch,var(--foreground)_8%,transparent)] text-[var(--foreground)]",
    };

    const sizes: Record<string, string> = {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md gap-1.5 px-3",
        lg: "h-10 rounded-md px-6",
        icon: "size-9",
        "icon-sm": "size-8",
    };
</script>

<button
    {type}
    {disabled}
    {title}
    class={cn(base, variants[variant], sizes[size], className)}
    on:click
    {...$$restProps}
>
    <slot />
</button>
